var exports = {
  "O": "x234b8571--6e39e0--rating",
  "D": "x234b8571--6e39e0--title",
};

module.exports = exports;
